import {SourcingType} from '../../../hooks/useSourcingType';
import {
  ClassifiedsAdInactiveFlags,
  isClassifiedsAdInactive,
} from '../../../utils/isClassifiedsAdInactive';

export function isComparisonVehicleInactive(
  sourcingType: SourcingType,
  vehicle: ClassifiedsAdInactiveFlags
) {
  return sourcingType === SourcingType.CLASSIFIEDS
    ? isClassifiedsAdInactive(vehicle)
    : vehicle.isSold === true;
}
